module.exports = __webpack_public_path__ + "img/1-quad.10914119.png";